import React from 'react';
import { ContentPage } from '../MerchandiserLayout';
import Reports from '../../../../../components/Reports/Reports';

function MerchandiserReportsPage() {
  return (
    <ContentPage
      variant="elevation"
      sx={{ flex: '1', width: '100%', padding: '0 3rem' }}
    >
      <Reports />
    </ContentPage>
  );
}

export default MerchandiserReportsPage;
